/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type AssetServiceLogCreateRequestEventType =
    (typeof AssetServiceLogCreateRequestEventType)[keyof typeof AssetServiceLogCreateRequestEventType];

export const AssetServiceLogCreateRequestEventType = {
    CALIBRATED: 'CALIBRATED',
    INSPECTED: 'INSPECTED',
    REPLACED: 'REPLACED',
    SERVICED: 'SERVICED'
} as const;
